import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import Pasos from "./Pasos";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/reservas",
    label: "Reservas",
  },
  {
    path: "/guarderia",
    label: "Guarderia",
    isActive: true,
  },
];

function ReservarGuarderia() {
  return (
    <Page
      title="Reserva de Guardería"
      description="Agendamiento de días de guardería para mascota."
      breadCrumbs={breadCrumbs}
    >
      <Pasos />
    </Page>
  );
}

export default ReservarGuarderia;
